// Small shared constants and pure helper functions used by avatarEngine
export const DEFAULT_OUTPUT = {
  width: 640,
  height: 360,
  fps: 24
}

export const LANDMARKS = {
  leftEye: 33,
  rightEye: 263,
  noseTip: 1,
  forehead: 10,
  chin: 152,
  leftEyeInner: 133,
  rightEyeInner: 362,
  leftEyeUpper: 159,
  leftEyeLower: 145,
  rightEyeUpper: 386,
  rightEyeLower: 374,
  mouthLeft: 78,
  mouthRight: 308,
  mouthUpper: 13,
  mouthLower: 14
}

export const FACE_MESH_POINT_COUNT = 478

export const FACE_GEOMETRY_ANCHORS = [
  10, 152, 1, 6, 9, 33, 133, 263, 362, 234, 454, 127, 356, 168, 197
]

export const NOSE_FEATURE_INDICES = [
  1, 2, 4, 5, 6, 8, 9, 19, 45, 48, 49, 51, 64, 94, 97, 98, 99, 102, 115, 129, 168, 195, 197, 275,
  278, 279, 281, 294, 326, 327, 328, 331, 344
]

export const CHEEK_FEATURE_INDICES = [
  50, 101, 117, 118, 123, 126, 129, 147, 187, 203, 205, 206, 209, 266, 280, 330, 346, 347, 352, 358,
  376, 411, 423, 425, 426, 429
]

export const JAW_EAR_FEATURE_INDICES = [
  10, 21, 54, 58, 67, 93, 103, 109, 127, 132, 136, 148, 149, 150, 152, 162, 172, 176, 234, 251, 288,
  297, 323, 332, 338, 356, 361, 365, 377, 378, 379, 389, 397, 400, 454
]

export const clamp = (value, min, max) => Math.max(min, Math.min(max, value))

export const lerp = (from, to, alpha) => from + (to - from) * alpha

// Byte clamp helper used by palette sampling and color ops
export const clampByte = (v) => clamp(Math.round(v), 0, 255)

export const meshQualityToStride = (quality) => {
  if (quality === 'performance') return 3
  if (quality === 'balanced') return 2
  return 1
}

export const prefer2dHairFromSettings = (settings = {}) => {
  if (settings?.prefer2dHair === true) return true
  if (settings?.prefer2dHair === false) return false
  return settings?.meshWorkerEnabled !== true
}

export default {
  DEFAULT_OUTPUT,
  LANDMARKS,
  FACE_MESH_POINT_COUNT,
  FACE_GEOMETRY_ANCHORS,
  NOSE_FEATURE_INDICES,
  CHEEK_FEATURE_INDICES,
  JAW_EAR_FEATURE_INDICES,
  clamp,
  lerp,
  clampByte,
  meshQualityToStride,
  prefer2dHairFromSettings
}
